import { useState, useEffect } from "react";
import { replaceUnderscore } from "../../../../../CommonFunction/common";
import { FormInputSectionComponent } from "../../../FormInputSectionComponent/FormInputSectionComponent";
import Input from "../../../Input/Input";
import { updateSingleField, updateValueForm } from "../../../FormInputSectionComponent/formUtils";

const AddStockItemSection = ({
  fielddata,
  inputfields,
  Type,
  Data,
  handleErrorsChange,
  ValidationName,
  TypeOfPortal,
  formkey,
  HanldeChangeonForm,
  formRef,
  TypeOfSelection,
  SelectedData,
  setSelectedData,
  FormData,
  setFirstLoad,
}) => {
  // const [SelectedData, setSelectedData] = useState("Goods");
  const [fields, setFields] = useState(inputfields);

  const handleSelectedDataChange = (e) => {
    setSelectedData(e.target.value);
  };

  useEffect(() => {
    let newFields = [...fields];

    // If SelectedData is present, we can access the specific TypeOfSelection for that key
    if (SelectedData) {
      // Get the selected field configuration based on SelectedData
      const selectedFieldConfig = TypeOfSelection[SelectedData];
      console.log(selectedFieldConfig);
      // Find the index of the current field if it matches the selected type
      const existingIndex = fields.findIndex(
        (field) => field.name === selectedFieldConfig?.name && field.label !== selectedFieldConfig?.label
      );

      // Update or add the new field configuration
      if (existingIndex !== -1) {
        newFields[existingIndex] = selectedFieldConfig;
      } else {
        // newFields.push(selectedFieldConfig);
      }

      // Set the updated fields array
      setFields(newFields);

      setTimeout(() => {
        updateValueForm(formRef, FormData);
      }, 100);
    }
  }, [SelectedData]);
  console.log(fields);
  return (
    <div className="FormSectionParent">
      <div className="VendorAccountradioContainer">
        {Object.entries(TypeOfSelection).map(([key, { name, label }]) => (
          <>
            <Input
              EMTQuery=""
              type="radio"
              id={key}
              name="SelectedData"
              value={key}
              checked={SelectedData === key}
              handleInputChange={handleSelectedDataChange}
              handleBlur={() => {}}
              InputConfig={{ type: "radio" }}
            />
            <label htmlFor={key}>{label === "HSN Code" ? "Goods" : label == "SAC Code" ? "Service" : label}</label>
          </>
        ))}
      </div>
      <>
        <div className="sectionHeadings">{replaceUnderscore(Type)}</div>
        <div className="FormSection">
          <FormInputSectionComponent
            fielddata={fielddata}
            inputfields={fields}
            Type={Type}
            onErrorsChange={handleErrorsChange}
            onhandleFormikChange={HanldeChangeonForm}
            ValidationName={ValidationName}
            TypeOfPortal={TypeOfPortal}
            formkey={formkey}
            formRef={formRef}
            setFirstLoad={setFirstLoad}
          />
        </div>
      </>
    </div>
  );
};

export default AddStockItemSection;
